import { connect } from 'react-redux'
import Admin from '../../layouts/Admin/Admin'
import { logout, succeedLogin, getUser, getServerConfig } from '../../action/userAction'
import JWTManager from '../../constant/JWTManager'

function mapStateToProps(state, ownProps) {
    return {
        login: state.getIn(['data', 'login']),
        access_token: state.getIn(['data', 'access_token']),
        refresh_token: state.getIn(['data', 'refresh_token']),
        user: state.getIn(['data', 'user']),
        token_expiry: state.getIn(['data', 'token_expiry']),
        config: state.getIn(['data', 'config']),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        toLogout: () => dispatch(logout()),
        
        // Replace toVerifyToken with a function that checks token validity using JWTManager
        checkTokenValidity: () => {
            if (JWTManager.hasValidToken()) {
                dispatch(succeedLogin());
                return true;
            }
            return false;
        },
        
        succeedLogin: () => dispatch(succeedLogin()),
        
        getUser: () => {
            dispatch(getUser())
        },

        getServerConfig: () => {
            dispatch(getServerConfig())
        }


    }
}

const AdminLayoutContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Admin)

export default AdminLayoutContainer